import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs';

@Injectable()
export class CompanyShellService {

    public OnLeafChanged = new Subject();

    // Service message commands
    refreshCompanyTree() {
        this.OnLeafChanged.next();
    }
}
